module.exports = __webpack_public_path__ + "static/media/house-blue_icon.13af03ac.svg";